/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Forward_Email_InstructionsInputs */

const en_mobile_forward_email_instructions = /** @type {(inputs: Mobile_Forward_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward any email or newsletter to the address above from your account email, and we'll turn it into audio in your library.`)
};

const es_mobile_forward_email_instructions = /** @type {(inputs: Mobile_Forward_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenvía cualquier correo o newsletter a la dirección anterior desde el correo de tu cuenta, y lo convertiremos en audio en tu biblioteca.`)
};

/**
* | output |
* | --- |
* | "Forward any email or newsletter to the address above from your account email, and we'll turn it into audio in your library." |
*
* @param {Mobile_Forward_Email_InstructionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_forward_email_instructions = /** @type {((inputs?: Mobile_Forward_Email_InstructionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Forward_Email_InstructionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_forward_email_instructions(inputs)
	return en_mobile_forward_email_instructions(inputs)
});